import { createMuiTheme } from "@material-ui/core/styles";

import variants from "./variants";
import typography from "./typography";
import overrides from "./overrides";
import breakpoints from "./breakpoints";
import props from "./props";
import shadows from "./shadows";

const theme = createMuiTheme({
  spacing: 4,
  breakpoints: breakpoints,
  overrides: overrides,
  props: props,
  typography: typography,
  shadows: shadows,
  body: variants.body,
  header: variants.header,
  palette: variants.palette,
  sidebar: variants.sidebar,
});

export type Theme = typeof theme;

export default theme;
